var _circle, _circle2, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_angular_3334_32898)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#090000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3334_32898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4477 2.34525C11.5974 1.88459 12.2491 1.88459 12.3988 2.34525L14.2806 8.13704C14.3476 8.34306 14.5396 8.48254 14.7562 8.48254H20.846C21.3304 8.48254 21.5318 9.10234 21.1399 9.38704L16.2131 12.9666C16.0379 13.0939 15.9646 13.3196 16.0315 13.5256L17.9134 19.3174C18.063 19.778 17.5358 20.1611 17.1439 19.8764L12.2171 16.2969C12.0419 16.1696 11.8046 16.1696 11.6294 16.2969L6.70256 19.8764C6.3107 20.1611 5.78347 19.778 5.93314 19.3174L7.81501 13.5256C7.88195 13.3196 7.80862 13.0939 7.63337 12.9666L2.70658 9.38704C2.31472 9.10234 2.51611 8.48254 3.00047 8.48254H9.09033C9.30694 8.48254 9.49892 8.34306 9.56585 8.13704L11.4477 2.34525Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3334_32898)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3334_32898)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.92334,
    cy: 9.38184,
    rx: 4,
    ry: 3.5,
    fill: "#D87C8E"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3334_32898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4477 2.34525C11.5974 1.88459 12.2491 1.88459 12.3988 2.34525L14.2806 8.13704C14.3476 8.34306 14.5396 8.48254 14.7562 8.48254H20.846C21.3304 8.48254 21.5318 9.10234 21.1399 9.38704L16.2131 12.9666C16.0379 13.0939 15.9646 13.3196 16.0315 13.5256L17.9134 19.3174C18.063 19.778 17.5358 20.1611 17.1439 19.8764L12.2171 16.2969C12.0419 16.1696 11.8046 16.1696 11.6294 16.2969L6.70256 19.8764C6.3107 20.1611 5.78347 19.778 5.93314 19.3174L7.81501 13.5256C7.88195 13.3196 7.80862 13.0939 7.63337 12.9666L2.70658 9.38704C2.31472 9.10234 2.51611 8.48254 3.00047 8.48254H9.09033C9.30694 8.48254 9.49892 8.34306 9.56585 8.13704L11.4477 2.34525Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3334_32898)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3334_32898)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4059,
    cy: 10.2226,
    rx: 6.61939,
    ry: 3.5,
    transform: "rotate(-30 11.4059 10.2226)",
    fill: "#D6CA5C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3334_32898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4477 2.34525C11.5974 1.88459 12.2491 1.88459 12.3988 2.34525L14.2806 8.13704C14.3476 8.34306 14.5396 8.48254 14.7562 8.48254H20.846C21.3304 8.48254 21.5318 9.10234 21.1399 9.38704L16.2131 12.9666C16.0379 13.0939 15.9646 13.3196 16.0315 13.5256L17.9134 19.3174C18.063 19.778 17.5358 20.1611 17.1439 19.8764L12.2171 16.2969C12.0419 16.1696 11.8046 16.1696 11.6294 16.2969L6.70256 19.8764C6.3107 20.1611 5.78347 19.778 5.93314 19.3174L7.81501 13.5256C7.88195 13.3196 7.80862 13.0939 7.63337 12.9666L2.70658 9.38704C2.31472 9.10234 2.51611 8.48254 3.00047 8.48254H9.09033C9.30694 8.48254 9.49892 8.34306 9.56585 8.13704L11.4477 2.34525Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3334_32898)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3334_32898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 5.88175C23.5326 7.67046 20.0389 14.6038 15.2788 17.352C10.5188 20.1002 5.03247 22.6706 3.99976 20.8819C2.96705 19.0932 6.77902 13.6227 11.5391 10.8745C16.2991 8.1263 21.4672 4.09304 22.4999 5.88175Z",
    fill: "#76DECB"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3334_32898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4477 2.34525C11.5974 1.88459 12.2491 1.88459 12.3988 2.34525L14.2806 8.13704C14.3476 8.34306 14.5396 8.48254 14.7562 8.48254H20.846C21.3304 8.48254 21.5318 9.10234 21.1399 9.38704L16.2131 12.9666C16.0379 13.0939 15.9646 13.3196 16.0315 13.5256L17.9134 19.3174C18.063 19.778 17.5358 20.1611 17.1439 19.8764L12.2171 16.2969C12.0419 16.1696 11.8046 16.1696 11.6294 16.2969L6.70256 19.8764C6.3107 20.1611 5.78347 19.778 5.93314 19.3174L7.81501 13.5256C7.88195 13.3196 7.80862 13.0939 7.63337 12.9666L2.70658 9.38704C2.31472 9.10234 2.51611 8.48254 3.00047 8.48254H9.09033C9.30694 8.48254 9.49892 8.34306 9.56585 8.13704L11.4477 2.34525Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3334_32898)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3334_32898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9233 4.38184C15.9233 6.31483 14.3563 7.88184 12.4233 7.88184C10.4903 7.88184 6.5 10.933 6.5 9C6.5 7.067 10.4903 0.881836 12.4233 0.881836C14.3563 0.881836 15.9233 2.44884 15.9233 4.38184Z",
    fill: "#E5B019"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3334_32898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4477 2.34525C11.5974 1.88459 12.2491 1.88459 12.3988 2.34525L13.9439 7.10057C14.2116 7.92462 14.9795 8.48254 15.846 8.48254H20.846C21.3304 8.48254 21.5318 9.10234 21.1399 9.38704L17.0948 12.326C16.3938 12.8353 16.1005 13.738 16.3683 14.5621L17.9134 19.3174C18.063 19.778 17.5358 20.1611 17.1439 19.8764L13.0988 16.9374C12.3978 16.4282 11.4487 16.4282 10.7477 16.9375L6.70256 19.8764C6.3107 20.1611 5.78347 19.778 5.93314 19.3174L7.47824 14.5621C7.74599 13.738 7.45267 12.8353 6.7517 12.326L2.70658 9.38704C2.31472 9.10234 2.51611 8.48254 3.00047 8.48254H8.00051C8.86697 8.48254 9.63488 7.92461 9.90262 7.10057L11.4477 2.34525Z",
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3334_32898)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3334_32898)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.4233,
    cy: 18.3818,
    r: 3.5,
    fill: "#2381DF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3334_32898",
    x: -2.07666,
    y: 2.88184,
    width: 14,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3334_32898"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3334_32898",
    x: 2.41064,
    y: 2.73462,
    width: 17.9907,
    height: 14.9761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3334_32898"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3334_32898",
    x: 0.82959,
    y: 2.43921,
    width: 24.8521,
    height: 22.0361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3334_32898"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3334_32898",
    x: 3.5,
    y: -2.11816,
    width: 15.4233,
    height: 14.7598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3334_32898"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3334_32898",
    x: 9.92334,
    y: 11.8818,
    width: 13,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3334_32898"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_3334_32898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#6EBFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#D9D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281831,
    stopColor: "#7D56A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38619,
    stopColor: "#793462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448031,
    stopColor: "#973D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534391,
    stopColor: "#935200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599596,
    stopColor: "#C9BD50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667568,
    stopColor: "#9BD6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794841,
    stopColor: "#02478D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022C74"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.475f886c823f0233fd30913cfaf6ae58.svg";
export { ForwardRef as ReactComponent };